import './appointments-list.component.js';
import './appointments-list.controller.js';
import './_appointments-list.styles.scss';

import groupApptByDate from 'utils/group-appts-by-date.js';

angular
.module('inkfinder')
.config(function($stateProvider, USER_ROLES) {
  $stateProvider
  .state('inkfinder.appointments-list', {
    url: '/appointments-list?page&status&sort&search',
    views: {
      '@': {
        component: 'inkAppointmentsList'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      },
      status: {
        value: 'All types of',
        dynamic: true
      },
      sort: {
        value: 'Appointment date',
        dynamic: true
      },
      search: {
        value: '',
        dynamic: true
      }
    },
    resolve: {
      $title: (() => 'Appointments List'),
      appointments: function(
      $stateParams, Appointments, MergeProjects, $document) {
        let search = $stateParams;
        return Appointments.get(search).then(function(appointments) {
          if (appointments.results.length > 0) {
            return MergeProjects.merge(appointments.results)
            .then(function(mergedData) {
              appointments.results = mergedData;
              let top = 0;
              let duration = 500; // milliseconds
              $document.scrollTop(top, duration);
              appointments.dateGroups =
              groupApptByDate(appointments.results);
              return appointments;
            });
          }
          appointments.results = [];
          let top = 0;
          let duration = 500; // milliseconds
          $document.scrollTop(top, duration);
          appointments.dateGroups =
          groupApptByDate(appointments.results);
          return appointments;
        });
      }
    },
    bindings: {
      $transition$: '<',
      appointments: '<'
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    }
  });
});



// WEBPACK FOOTER //
// ./components/appointments-list/index.js